import type { DecorationFields } from "./types";

const FIELD = /\{([a-z_]+)\}/g;

export const PRODUCT_FIELDS = ["name", "price", "weight", "calories", "proteins", "fats", "carbs"] as const;

export const fillFields = (text: string, fields: DecorationFields | undefined): string | null => {
	if (!fields) return text;

	let missing = false;
	const filled = text.replace(FIELD, (_, name: string) => {
		const value = fields[name];
		if (!value) missing = true;
		return value ?? "";
	});
	return missing ? null : filled;
};
